// Static content for the Neighbours Brick & Build marketing site
export const COMPANY = {
  name: "Neighbours Brick & Build Ltd",
  short: "Neighbours Brick & Build",
  tagline: "Built next door. Built to last.",
  logo: "https://customer-assets.emergentagent.com/job_build-neighbours/artifacts/yq5ymng1_Screenshot%20%2833%29.png",
  phone: "+44 7957 011862",
  email: "neighboursbrickbuild@yahoo.com",
  address: "Bracknell, Berkshire, RG42",
  hours: "Mon – Fri · 8:00 – 18:00",
  founded: 2008,
  social: {
    instagram: "https://www.instagram.com/neighboursbrikbuild?igsh=MWNteGtocno5ZHhkeQ=="
  }
};

export const STATS = [
  { value: "11", label: "Years building locally" },
  { value: "240+", label: "Projects delivered" },
  { value: "98%", label: "Repeat & referral work" }
];

export const SERVICES = [
  {
    slug: "bricklaying",
    title: "Bricklaying & Masonry",
    short: "Hand-laid brickwork with proper bond, plumb and patience.",
    description:
      "Our masons treat every course like it’s the front of their own house. From garden walls and chimneys to load-bearing facades, we work with reclaimed, handmade and heritage brick to match the character of your street.",
    image: "https://images.pexels.com/photos/19688828/pexels-photo-19688828.jpeg",
    bullets: [
      "Reclaimed & handmade brick matching",
      "Lime mortar & traditional pointing",
      "Garden walls, chimneys, retaining walls",
      "Conservation-area sympathetic work"
    ]
  },
  {
    slug: "extensions",
    title: "Extensions",
    short: "Single-storey, double-storey and wrap-around extensions.",
    description:
      "Bigger kitchens, brighter mornings, more room to breathe. We design and build extensions that feel like they were always part of the house — proper foundations, structural steels, and a finish that lifts the whole property.",
    image:
      "https://images.unsplash.com/photo-1572534382964-664044795b84?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBob21lJTIwZXh0ZW5zaW9uJTIwZXh0ZXJpb3J8ZW58MHx8fHwxNzc3MjkwNzI1fDA&ixlib=rb-4.1.0&q=85",
    bullets: [
      "Rear, side-return & wrap-around builds",
      "Loft conversions & dormers",
      "Steelwork & structural calcs",
      "Planning & building-control liaison"
    ]
  },
  {
    slug: "new-builds",
    title: "New Builds",
    short: "Ground-up homes, granny annexes and infill plots.",
    description:
      "From the first peg in the ground to the day you turn the key, we manage the whole build. Energy-efficient construction, careful site management and a single point of contact you can actually ring.",
    image:
      "https://static.prod-images.emergentagent.com/jobs/861de20d-72a6-47d7-860f-aae5d16b275d/images/b4953b35e6218c809a2aef21f47788de38366055d7551511636b8d984fd34302.png",
    bullets: [
      "Detached & semi-detached homes",
      "Garden annexes & garden offices",
      "Air-tight, low-energy detailing",
      "10-year structural warranty options"
    ]
  },
  {
    slug: "renovations",
    title: "Renovations & Refurbishments",
    short: "Whole-house refurbs that don’t cut corners.",
    description:
      "Tired Victorian terrace? Damp-ridden 70s semi? We strip back, rewire, replumb, replaster and reinstate — keeping the original character and quietly fixing the bits no one ever saw.",
    image: "https://images.pexels.com/photos/30081237/pexels-photo-30081237.jpeg",
    bullets: [
      "Full-house refurbs",
      "Period-property restoration",
      "Damp-proofing & timber treatment",
      "Bathrooms, kitchens & joinery"
    ]
  },
  {
    slug: "commercial",
    title: "Commercial",
    short: "Shop fit-outs, offices and small mixed-use schemes.",
    description:
      "We work evenings, early mornings and weekends so your business can keep trading. Local cafés, dental practices, offices and small developers — we treat your deadline as ours.",
    image:
      "https://images.unsplash.com/photo-1602636403821-e43d50123cb7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwyfHxicmljayUyMHdhbGwlMjB0ZXh0dXJlfGVufDB8fHx8MTc3NzI5MDc0Nnww&ixlib=rb-4.1.0&q=85",
    bullets: [
      "Café & retail fit-outs",
      "Office refurbishments",
      "Mixed-use small developments",
      "Out-of-hours phased works"
    ]
  }
];

export const PROJECTS = [
  {
    id: "p1",
    title: "Extension",
    category: "extensions",
    location: "Caversham, Reading",
    year: 2024,
    image:
      "https://customer-assets.emergentagent.com/job_build-neighbours/artifacts/0eobmv8h_2b44982a-6b2a-42a3-8973-20f7cde333a2.jpg",
    blurb: "5m rear extension with frameless rooflight and reclaimed Reading red-brick.",
    description:
      "A full-width 5m rear extension that opened the back of a 1930s semi into a single light-filled kitchen and dining space. Frameless rooflight, hand-cut reclaimed red-brick to match the original elevation, and a steel goalpost to lose the back wall.",
    scope: [
      "Foundations, drainage and building-control sign-off",
      "Steel goalpost & structural opening",
      "Reclaimed red-brick to match existing",
      "Frameless rooflight & bi-fold doors",
      "Plastering, electrics and final decoration"
    ],
    gallery: [
      "https://customer-assets.emergentagent.com/job_build-neighbours/artifacts/9cwf3onw_a512935a-ce52-42a5-acfd-5c196d569f6c.jpg",
      "https://customer-assets.emergentagent.com/job_build-neighbours/artifacts/muvna5w9_2b05267a-c92a-4b3a-8dfd-dc385088ed2b.jpg",
      "https://customer-assets.emergentagent.com/job_build-neighbours/artifacts/0ahtvmhf_fdc83570-5317-49e7-925e-f17bb6de8388.jpg"
    ]
  },
  {
    id: "p2",
    title: "Chimney rebuild",
    category: "bricklaying",
    location: "Henley-on-Thames",
    year: 2024,
    image:
      "https://customer-assets.emergentagent.com/job_build-neighbours/artifacts/90vmzaam_81f88bc2-93e4-4d26-b57f-095d1c3e2d6c.jpg",
    blurb: "Conservation-area chimney rebuilt with hand-made bricks and lime mortar.",
    description:
      "A leaning Victorian stack rebuilt course-by-course in a conservation area. Hand-made bricks sourced to match the originals, lime mortar mixed on site, traditional weather-struck pointing and new lead flashings.",
    scope: [
      "Scaffold, strip back to sound brickwork",
      "Hand-made brick matching",
      "NHL3.5 lime mortar, weather-struck pointing",
      "New lead flashings & flaunching",
      "Conservation officer sign-off"
    ],
    gallery: [
      "https://customer-assets.emergentagent.com/job_build-neighbours/artifacts/4buoq8sd_746b15d8-44c4-4f67-9728-f2b37e8745d2.jpg",
      "https://customer-assets.emergentagent.com/job_build-neighbours/artifacts/ob0z6fh8_52640c13-2747-491a-818c-9750038a0d36.jpg",
      "https://customer-assets.emergentagent.com/job_build-neighbours/artifacts/h3p87fgu_cff4aefe-ef27-46d9-8d1e-6e677ae7d72b.jpg"
    ]
  },
  {
    id: "p3",
    title: "Garden studio new build",
    category: "new-builds",
    location: "Wokingham",
    year: 2023,
    image:
      "https://images.unsplash.com/photo-1572534382964-664044795b84?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBob21lJTIwZXh0ZW5zaW9uJTIwZXh0ZXJpb3J8ZW58MHx8fHwxNzc3MjkwNzI1fDA&ixlib=rb-4.1.0&q=85",
    blurb: "Insulated garden studio with timber cladding and warm-roof detail.",
    description:
      "A standalone insulated garden studio used as a home office. Concrete pad foundations, timber-frame walls with high-spec insulation, larch cladding and a warm-roof detail to keep it usable through winter.",
    scope: [
      "Concrete pad foundations",
      "Timber-frame & high-spec insulation",
      "Larch cladding & warm-roof",
      "Electrics, lighting and data run from the house",
      "Internal joinery and decoration"
    ],
    gallery: []
  },
  {
    id: "p4",
    title: "Garden wall — brickwork & stonework",
    category: "bricklaying",
    location: "Maidenhead",
    year: 2024,
    image:
      "https://customer-assets.emergentagent.com/job_build-neighbours/artifacts/3igcj4pk_a6f5ba90-2d1f-4226-8197-19c5195f4b54.jpg",
    blurb: "32m boundary garden wall built in reclaimed red-brick with soldier-course coping.",
    description:
      "A 32m boundary garden wall replacing a tired panel fence. Concrete strip foundation, reclaimed red-brick laid in a Flemish bond, soldier-course coping and weep-holes to keep it dry through winter.",
    scope: [
      "Strip foundation with rebar",
      "Reclaimed red-brick, Flemish bond",
      "Soldier-course coping",
      "Weep-holes & dpc",
      "Mortar joint to weather and soften over time"
    ],
    gallery: [
      "https://customer-assets.emergentagent.com/job_build-neighbours/artifacts/fe709xhc_eeff18c7-1bcc-45a0-bede-672ffed27074.jpg",
      "https://customer-assets.emergentagent.com/job_build-neighbours/artifacts/djixbl44_82278400-b521-4fc9-b636-dec28ba991ed.jpg",
      "https://customer-assets.emergentagent.com/job_build-neighbours/artifacts/ckr58oxq_2a6ac4bf-73e1-4b46-b0ae-75dab744468d.jpg",
      "https://customer-assets.emergentagent.com/job_build-neighbours/artifacts/pm8fa3f2_2e149172-2fca-450c-81d8-da41f3a1e3eb.jpg",
      "https://customer-assets.emergentagent.com/job_build-neighbours/artifacts/o366hvs3_bcbb083c-f6e0-4643-bb08-c55214ae3011.jpg"
    ]
  },
  {
    id: "p5",
    title: "Patio",
    category: "bricklaying",
    location: "Ascot",
    year: 2024,
    image:
      "https://customer-assets.emergentagent.com/job_build-neighbours/artifacts/hbb8frk3_our-works-16.webp",
    blurb:
      "Riven grey sandstone patio laid on a full mortar bed, framed with a red-brick raised step and edging.",
    description:
      "A new garden patio replacing a cracked concrete slab. Riven grey sandstone laid on a full mortar bed, with a raised red-brick step and edging that ties back to the brick of the house.",
    scope: [
      "Excavation, hardcore sub-base",
      "Full mortar bed for slab",
      "Riven grey sandstone, joints brushed in",
      "Red-brick raised step & edging",
      "Falls set away from the house for drainage"
    ],
    gallery: [
      "https://customer-assets.emergentagent.com/job_build-neighbours/artifacts/h4p802cl_785409fc-4298-4d38-8cd3-9865ba8b5758.jpg",
      "https://customer-assets.emergentagent.com/job_build-neighbours/artifacts/u2264t9y_4e4a2068-41d6-4c17-8e5a-386021b092b5.jpg"
    ]
  },
  {
    id: "p6",
    title: "Whole-house repointing",
    category: "bricklaying",
    location: "Newbury",
    year: 2023,
    image:
      "https://customer-assets.emergentagent.com/job_build-neighbours/artifacts/nb3adk1d_How%20to%20Pointing%20120%2050.jpg",
    blurb:
      "Front and side elevations raked out and repointed in NHL3.5 lime, weather-struck finish.",
    description:
      "Front and side elevations of a Victorian semi raked out by hand and gun, then repointed in NHL3.5 lime mortar with a weather-struck finish. Soft, breathable joints that protect the brick instead of trapping moisture.",
    scope: [
      "Mechanical & hand raking-out of failed joints",
      "Brick wash and damp-down",
      "NHL3.5 lime mortar, mixed on site",
      "Weather-struck pointing finish",
      "Sheeting & dust-extraction throughout"
    ],
    gallery: []
  }
];

export const TESTIMONIALS = [
  {
    name: "Aisha & Tom",
    project: "Side-return extension, Tilehurst",
    quote:
      "They turned up when they said they would, finished a week early, and Cleared the site spotless. The brickwork is genuinely the nicest thing about our house now.",
    rating: 5
  },
  {
    name: "Priya Shah",
    project: "Whole-house refurb, Twyford",
    quote:
      "We lived in a building site for four months and never once dreaded coming home. Honest pricing, calm site manager, and the finish is beautiful.",
    rating: 5
  },
  {
    name: "Marco Lenti",
    project: "Café fit-out, Bracknell",
    quote:
      "They worked nights so we didn’t lose a single trading day. Already booking them for our second site.",
    rating: 5
  },
  {
    name: "The Robertsons",
    project: "Garden studio, Wokingham",
    quote:
      "Felt like a neighbour helping out, not a contractor. We got more space, more light, and the same builder still pops by to check the roof after a storm.",
    rating: 5
  },
  {
    name: "Hannah W.",
    project: "Heritage chimney, Henley-on-Thames",
    quote:
      "Brick-matching was indistinguishable from the original. Conservation officer signed it off without a single comment.",
    rating: 5
  },
  {
    name: "Daniel Okafor",
    project: "Garden annex, Crowthorne",
    quote:
      "Clear quote, clear timeline, clear invoices. No surprises — and the build is rock solid.",
    rating: 5
  }
];

export const VALUES = [
  {
    title: "Built next door",
    body: "We live where we build. If something’s not right we’re ten minutes away, not on the other side of the M4."
  },
  {
    title: "Honest fixed prices",
    body: "Detailed written quotes. No vague day-rates, no end-of-job surprises."
  },
  {
    title: "One site manager",
    body: "You get one phone number, one face on site, every day. Not a different sub each week."
  }
];

export const ACCREDITATIONS = [];

export const FAQS = [
  {
    q: "How do you price a job?",
    a: "After a free site visit we send a fixed-price written quote with a clear scope, a payment schedule tied to milestones, and provisional sums clearly flagged."
  },
  {
    q: "How long do projects usually take?",
    a: "A side-return is typically 5–14 weeks. A full house refurb 2–5 months. New builds 6–12 months. We agree the programme up front and update you weekly."
  },
  {
    q: "What guarantees do you offer?",
    a: "12 months on labour as standard, plus manufacturer warranties on materials. Insurance-backed 10-year warranties available on new builds and major extensions."
  }
];
